import LegalLayout from "@/components/LegalLayout";

export default function Terms() {
  return (
    <LegalLayout title="Terms of Service" updated="December 2025">
      <section data-testid="terms-content">
        <div>
          <h2>Acceptance of terms</h2>
          <p>
            By accessing or using the JLY Services website and services, you agree to
            these Terms of Service. If you do not agree, please do not use the site.
          </p>
        </div>
        <div>
          <h2>Our services</h2>
          <p>
            JLY Services provides independent brokerage and information services,
            including solar &amp; battery quoting and essential services brokering.
            Quotes and recommendations are provided for your consideration; final
            agreements are between you and the relevant provider.
          </p>
        </div>
        <div>
          <h2>No guarantee</h2>
          <p>
            While we work to provide accurate, impartial information, we do not
            guarantee specific savings, outcomes or the availability of any product
            or provider. All estimates are indicative.
          </p>
        </div>
        <div>
          <h2>Your responsibilities</h2>
          <p>
            You agree to provide accurate information and to use our services lawfully.
            You are responsible for reviewing any provider's terms before entering into
            an agreement.
          </p>
        </div>
        <div>
          <h2>Intellectual property</h2>
          <p>
            All content on this site, including text, graphics and logos, is the
            property of JLY Services unless otherwise stated and may not be reproduced
            without permission.
          </p>
        </div>
        <div>
          <h2>Limitation of liability</h2>
          <p>
            To the extent permitted by law, JLY Services is not liable for any indirect
            or consequential loss arising from use of the site or services.
          </p>
        </div>
        <div>
          <h2>Contact</h2>
          <p>
            Questions about these terms? Reach us through the <a href="/#contact" className="text-primary underline underline-offset-2">contact form</a> on our website.
          </p>
        </div>
      </section>
    </LegalLayout>
  );
}
